const {config} = require('./config-merchant');
const path = require('path')

module.exports = {
    i18n: {
      defaultLocale: config.defaultLanguage,
      locales: config.enabledLanguagues,
    },
    localePath: path.resolve('./public/static/locales'),
}